// Video instructions for the "Как пользоваться" page, in the order they are shown.
// Each video is hosted on Rutube or VK Video (access "по ссылке") and embedded in the page:
//   { id: 'connect-wb', title: 'Подключение кабинета Wildberries', description: '…', url: 'https://rutube.ru/video/…/' }
// `id` goes into the page address (?v=…), so keep it short, latin and stable.
export const GUIDE_VIDEOS = [
  { id: 'overview', title: 'Краткий обзор на Marqit', url: 'https://rutube.ru/video/a140888a80def6aa7b30d0c755775ad2/' },
  { id: 'connect-account', title: 'Как подключить свой аккаунт к Marqit', url: 'https://rutube.ru/video/b852b0bc05078bd0119823c1752f3b5b/' },
];

// Turns a link copied from the video site into the address of its embedded player.
// Rutube: rutube.ru/video/<id>/ and private rutube.ru/video/private/<id>/?p=<key>.
// VK Video: the src from "Поделиться → Экспортировать" (video_ext.php?oid=…&id=…&hash=…) is used as is.
export const toEmbedUrl = (url) => {
  let u;
  try {
    u = new URL(url);
  } catch {
    return null;
  }
  const host = u.hostname.replace(/^www\./, '');
  if (host === 'rutube.ru') {
    if (u.pathname.startsWith('/play/embed/')) return u.toString();
    const m = u.pathname.match(/^\/video\/(?:private\/)?([0-9a-f]{32})\/?$/i);
    if (!m) return null;
    const key = u.searchParams.get('p');
    return `https://rutube.ru/play/embed/${m[1]}/${key ? `?p=${encodeURIComponent(key)}` : ''}`;
  }
  if ((host === 'vkvideo.ru' || host === 'vk.com') && u.pathname === '/video_ext.php') {
    return u.toString();
  }
  return null;
};
